import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function StresTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['stres-testi']} />;
}
